if (!customElements.get('collection-promotion-copy')) {
  customElements.define(
    'collection-promotion-copy',
    class CollectionPromotionCopy extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.copyCode);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.copyCode);
        clearTimeout(this.resetTimer);
      }

      copyCode = async () => {
        try {
          await navigator.clipboard.writeText(this.dataset.copyValue);
        } catch {
          return;
        }

        const text = this.button?.querySelector('.btn__text');
        if (!text) return;

        text.textContent = this.button.dataset.copiedText;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          text.textContent = this.button.dataset.copyText;
        }, 1500);
      };
    },
  );
}
